<template>
    <div>
        <input-tag
            v-model="tags"
            :add-tag-on-blur="true"
            :validate="validate"
            @input="$emit('input', $event)"
        />

        <SuggestedTags
            v-if="suggestedTags"
            v-model="tags"
            :tags="suggestedTags"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
import InputTag from 'vue-input-tag';
import SuggestedTags from '@/components/SuggestedTags';
export default {
    name: 'InputTags',
    components: {
        InputTag,
        SuggestedTags,
    },
    model: {
        prop: 'sourceTags',
    },
    props: {
        sourceTags: { type: Array, default: () => [] },
        validate: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            tags: this.sourceTags,
            suggestedTags: this.$store.getters.project.suggestedTags
                ? [...this.$store.getters.project.suggestedTags]
                : [],
        };
    },
    watch: {
        sourceTags() {
            this.tags = [...this.sourceTags];
        },
    },
};
</script>

<style></style>
